import './modules/appointment-form';
import './modules/form-summary';
import './modules/form-calculation';